import Vue from "vue";
import Component from "vue-class-component";
import { Model, Prop, Watch } from "vue-property-decorator";
import { lockBodyScroll } from "@scrile/tools/dist/lib/Scrollhelpers";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";

@Component({ name: "Modal" })
export default class Modal extends Vue {
  @Prop({ type: Boolean, default: false })
  public readonly modal!: boolean;

  @Model("input", { required: true })
  public readonly value!: boolean;

  public element: Element | null = null;

  public modalClose(close: boolean = !this.modal) {
    close && this.$emit("input", false);
  }

  @Watch("value")
  public onValueChanged(value: boolean) {
    if (value) {
      this.element = document.activeElement;
      if (this.element) {
        (this.element as HTMLElement)?.blur();
      }
    } else {
      if (this.element) {
        (this.element as HTMLElement).focus();
      }
      this.element = null;
    }
  }

  public mounted() {
    const unwatch = this.$watch("value", lockBodyScroll);
    this.$once("hook:beforeDestroy", () => {
      if (this.value) lockBodyScroll(false);
      emitter.emit(EVENTS.STATUS_HIDE);
      unwatch();
    });

    this.value && lockBodyScroll(this.value);
  }
}
